<template>
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="fill: currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.625 1.625C2.34886 1.625 2.125 1.84886 2.125 2.125V15.875C2.125 16.1511 2.34886 16.375 2.625 16.375H11.375C11.6511 16.375 11.875 16.1511 11.875 15.875V5.81262H9.50001C8.49899 5.81262 7.68751 5.00114 7.68751 4.00012V1.625H2.625ZM8.81251 1.87317V4.00012C8.81251 4.37982 9.12031 4.68762 9.50001 4.68762H11.627L8.81251 1.87317ZM0.625 2.125C0.625 1.02043 1.52043 0.125 2.625 0.125H8.35723C8.88767 0.125 9.39637 0.335714 9.77145 0.710786L12.7892 3.72855C13.1643 4.10363 13.375 4.61233 13.375 5.14277V15.875C13.375 16.9796 12.4796 17.875 11.375 17.875H2.625C1.52043 17.875 0.625 16.9796 0.625 15.875V2.125ZM3.31249 9.00012C3.31249 8.68946 3.56432 8.43762 3.87499 8.43762H10.125C10.4356 8.43762 10.6875 8.68946 10.6875 9.00012C10.6875 9.31078 10.4356 9.56262 10.125 9.56262H3.87499C3.56432 9.56262 3.31249 9.31078 3.31249 9.00012ZM3.87499 10.9376C3.56432 10.9376 3.31249 11.1895 3.31249 11.5001C3.31249 11.8108 3.56432 12.0626 3.87499 12.0626H10.125C10.4356 12.0626 10.6875 11.8108 10.6875 11.5001C10.6875 11.1895 10.4356 10.9376 10.125 10.9376H3.87499ZM3.31249 14.0001C3.31249 13.6895 3.56432 13.4376 3.87499 13.4376H7.62499C7.93565 13.4376 8.18749 13.6895 8.18749 14.0001C8.18749 14.3108 7.93565 14.5626 7.62499 14.5626H3.87499C3.56432 14.5626 3.31249 14.3108 3.31249 14.0001Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
